// components/About.jsx
import React from "react";
import { Leaf, Wheat, Apple } from "lucide-react";

const Introducción = () => {
  return (
    <section
      id="nosotros"
      className="relative py-20 bg-gradient-to-b from-white via-orange-50 to-white overflow-hidden"
    >
      {/* Fondo decorativo */}
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/white-diamond.png')] opacity-10"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Texto central */}
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight drop-shadow-sm">
            Más de{" "}
            <span className="text-orange-600 drop-shadow-md">49 años</span> de
            experiencia en{" "}
            <span className="text-orange-600">semillas, granos y frutas secas</span>
          </h2>

          <div className="w-24 h-1 bg-orange-500 mx-auto mb-8 rounded-full"></div>

          <p className="text-lg md:text-xl text-gray-600 mb-12 leading-relaxed">
            Con más de <strong className="text-gray-900">49 años de experiencia</strong>,
            somos una empresa dedicada a la comercialización de{" "}
            <span className="text-orange-600 font-semibold">semillas, granos, especias</span> y
            una gran variedad de{" "}
            <span className="text-orange-600 font-semibold">frutas secas</span> de importación y exportación,
            disponibles tanto a granel como en presentaciones empacadas.
          </p>
        </div>

        {/* Tarjetas de productos */}
        <div className="grid gap-8 md:grid-cols-3 max-w-5xl mx-auto">
          <div className="bg-white/70 backdrop-blur-md rounded-xl shadow-lg p-6 text-center hover:shadow-2xl hover:-translate-y-1 transition duration-300 border border-orange-100">
            <Leaf className="w-12 h-12 text-orange-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Semillas</h3>
            <p className="text-gray-600 text-sm">
              Variedad de semillas de la más alta calidad para consumo e industria.
            </p>
          </div>

          <div className="bg-white/70 backdrop-blur-md rounded-xl shadow-lg p-6 text-center hover:shadow-2xl hover:-translate-y-1 transition duration-300 border border-orange-100">
            <Wheat className="w-12 h-12 text-orange-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Granos</h3>
            <p className="text-gray-600 text-sm">
              Comercialización de granos nacionales e importados, a granel y empacados.
            </p>
          </div>

          <div className="bg-white/70 backdrop-blur-md rounded-xl shadow-lg p-6 text-center hover:shadow-2xl hover:-translate-y-1 transition duration-300 border border-orange-100">
            <Apple className="w-12 h-12 text-orange-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Frutas Secas</h3>
            <p className="text-gray-600 text-sm">
              Amplia selección de frutas secas y deshidratadas para todos los gustos.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Introducción;
